import _ from 'lodash';
import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

// actions
import * as actions from './../actions/actions';

// components
import ContentBodyContainer from './../components/Content/ContentBodyContainer';

// components ui
import NavButtonsContainer from './../components/Content/UI/NavButtons/NavButtonsContainer';
import PagesCounter from './../components/Content/UI/PagesCounter';
import Breadcrumbs from './../components/Content/UI/Breadcrumbs';
import ModeButtons from './../components/Content/UI/ModeButtons';
import Results from './../components/Content/UI/Results';

class Content extends React.Component {
    constructor(props) {
        super(props);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    componentDidMount() {
        if (this.props.app.mode === 'EDIT') {
            this.refs.contentRootArea.addEventListener('click', this.handleDocumentClick);
        }
    }

    componentWillUnmount() {
        if (this.props.app.mode === 'EDIT') {
            this.refs.contentRootArea.removeEventListener('click', this.handleDocumentClick);
        }
    }

    handleDocumentClick(evt) {
        if (evt.target.classList.contains('component-list') && this.props.activeWidget !== null) {
            this.props.actions.setActiveWidget(null);
        }
    }

    render() {
        const { app, results, pagesList, activeId, actions } = this.props;
        const contentCss = classNames({
            content: true,
            [`content-${activeId}`]: true,
            'content-last': activeId === _.last(pagesList),
            'content-fullpage': app.mode !== 'EDIT',
            'content-fullpage-client': app.mode === 'CLIENT',
            'content-fullpage-preview': app.mode === 'PREVIEW',
        });

        return (
            <div ref="contentRootArea">
                {(app.mode === 'EDIT') ? <Breadcrumbs app={app} /> : null }
                {(app.mode !== 'CLIENT') ? <ModeButtons mode={app.mode} actions={actions} /> : null }

                <div className={contentCss}>
                    <div className="content-left" />
                    <div className="content-right">
                        <div className="object-1" />
                    </div>
                    <ContentBodyContainer />
                    <PagesCounter />
                    <NavButtonsContainer />
                    <div className="logo-myesti">
                        <span className="logo-myesti__label">Created by</span>
                        <a href="http://app.myesti.com" target="_blank" title="myesti.com"><span className="myesti" /></a>
                    </div>
                </div>

                {(app.mode === 'CLIENT') ? <Results mode={app.mode} results={results} /> : null }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
    results: state.results,
    activeId: state.pages.activeId,
    pagesList: state.pages.list,
    tools: state.tools,
    activeWidget: state.widgets.activeWidget,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Content.propTypes = {
    app: PropTypes.object.isRequired,
    activeId: PropTypes.number.isRequired,
    pagesList: PropTypes.array.isRequired,
    activeWidget: PropTypes.number,
    tools: PropTypes.object,
    results: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Content);



// WEBPACK FOOTER //
// ./src/_app/quick_response/containers/Content.jsx